class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.form = this.querySelector('form');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.submitButton = this.form?.querySelector('button');

    if (!this.input || !this.predictiveSearchResults || !this.form) return;

    this.lastSearchTerm = '';

    this.input.addEventListener(
      'input',
      this.debounce(() => {
        this.onChange();
      }, 300).bind(this)
    );

    this.input.addEventListener('focus', () => {
      this.onFocus();
    });

    this.input.addEventListener('click', () => {
      this.onFocus();
    });

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.onChange();
    });

    if (this.submitButton) {
      this.submitButton.type = 'button';
      this.submitButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.onChange();
      });
    }

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });

    this.predictiveSearchResults.addEventListener('click', (event) => {
      if (event.target.closest('.button-results')) {
        event.preventDefault();
        this.lastSearchTerm = '';
        this.onChange();
      }
    });
  }

  onFocus() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    if (
      searchTerm === this.lastSearchTerm &&
      this.predictiveSearchResults.style.display === 'block'
    ) {
      return;
    }

    this.lastSearchTerm = searchTerm;

    const params = new URLSearchParams({
      q: searchTerm,
      section_id: 'section-predictive-search',
      'resources[type]': 'product',
      'resources[limit]': '8',
      'resources[options][unavailable_products]': 'hide',
    });

    fetch(`/search/suggest?${params}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }

        return response.text();
      })
      .then((text) => {
        const section = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-section-predictive-search');

        if (!section) {
          this.close();
          return;
        }

        this.predictiveSearchResults.innerHTML = section.innerHTML;
        this.open();
      })
      .catch(() => {
        this.close();
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.input.setAttribute('aria-expanded', 'false');
    this.predictiveSearchResults.innerHTML = '';
    this.lastSearchTerm = '';
  }

  debounce(fn, wait) {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
